import { Icon } from '@ss/mtd-react';
import React, { FC } from 'react';
import { useRootStore } from '@src/model';
import dayjs from 'dayjs';
import { ISocialEduExperience } from '@src/types/resumeDetail/socialType';
import { ICampusEduExperience } from '@/src/types/resumeDetail/campusType';

import './index.scss';

interface IProps {
  data: ICampusEduExperience[] | ISocialEduExperience[];
  type: string;
  setMode: Function;
}

const EduExperienceView: FC<IProps> = (props) => {
  const { data, type, setMode } = props;

  const { campusResumeFormRefStore, socialResumeFormRefStore } = useRootStore();
  let storeRef;
  if (type === 'campus') {
    storeRef = campusResumeFormRefStore;
  }
  if (type === 'social') {
    storeRef = socialResumeFormRefStore;
  }

  const handleEdit = () => {
    setMode('edit');
    storeRef.setCurrentScrollRef('edu_experience_edit');
  };

  data?.forEach((item) => {
    if (item?.fullTimeStatus === true) item.fullTimeStatus = '全日制';
    else if (item?.fullTimeStatus === false) item.fullTimeStatus = '非全日制';
  });

  return (
    <div className="edu_experience_view model_view">
      <div className="model_title">
        <div>教育经历</div>
        <div className="edit_icon" onClick={() => handleEdit()}>
          <Icon type="edit-o" style={{ color: '#A9AFB8', fontSize: 22 }} />
        </div>
      </div>
      {/* @ts-ignore */}
      {data?.map((item) => (
        <div className="model_list" key={item.renderId}>
          {type === 'social' && (
            <div className="model_main">
              <div className="model_left">
                <div className="school">{item.school}</div>
                <div className="degree">
                  <span>{item.major}</span>
                  <span className="center">|</span>
                  <span>{item.degreeName}</span>
                </div>
              </div>
              <div className="model_right">
                {dayjs(item.startDate).isValid() ? dayjs(item.startDate).format('YYYY/MM') : item.startDate}-
                {/* eslint-disable-next-line no-nested-ternary */}
                {item.endDate === 253370736000000
                  ? '至今'
                  : dayjs(item.endDate).isValid()
                    ? dayjs(item.endDate).format('YYYY/MM')
                    : ''}
              </div>
            </div>
          )}
          {type === 'campus' && (
            <div>
              <div className="model_top">
                <div className="edu_left_info">
                  <div className="edu_name" />
                  {item.school}
                  <div className="edu_info">
                    <span>{item.major}</span>
                    <span className="center">|</span>
                    <span>{item.degreeName}</span>
                    <span className="center">|</span>
                    {item.fullTimeStatus && <span>{item.fullTimeStatus}</span>}
                    {item.fullTimeStatus && <span className="center">|</span>}
                    <span>成绩{item.scoreRankingName}</span>
                  </div>
                </div>

                <div className="edu_time">
                  {dayjs(item.startDate).isValid() ? dayjs(item.startDate).format('YYYY/MM') : ''}-
                  {/* eslint-disable-next-line no-nested-ternary */}
                  {item.endDate === 253370736000000
                    ? '至今'
                    : dayjs(item.endDate).isValid()
                      ? dayjs(item.endDate).format('YYYY/MM')
                      : ''}
                </div>
              </div>
              <div className="model_line" />
              <div className="model_bottom">
                <div className="label">
                  <div className="label_left">学院名称：</div>
                  <div className="label_right">{item.collegeName || ''}</div>
                </div>
                <div className="label">
                  <div className="label_left">研究方向：</div>
                  <div className="label_right">{item.researchDirection || '-'}</div>
                </div>
                {/* <div className="label">
                  <div className="label_left">是否统招：</div>
                  <div className="label_right">
                    {item?.unifiedEntrance == null ? '-' : item?.unifiedEntrance ? '统招' : '非统招'}
                  </div>
                </div> */}
                <div className="label">
                  <div className="label_left">实验室：</div>
                  <div className="label_right">
                    {item.labLevelName || item.laboratory
                      ? `${item?.labLevelName ? item.labLevelName : ''}${item?.laboratory ? item.laboratory : ''}`
                      : '-'}
                  </div>
                </div>
                <div className="label label_last">
                  <div className="label_left">导师：</div>
                  <div className="label_right">{item.mentor || '-'}</div>
                </div>
              </div>
            </div>
          )}
        </div>
      ))}
    </div>
  );
};

export default EduExperienceView;
